<template>
  <WsVersion
    label="點檢表公版版本列表"
    :localeMode="true"
    :id="$route.params.id"
    :modelName="modelName"
    :versionModelName="versionModelName"
    :fields="versionFields"
    :showFields="showFields"
    :hideOnNull="hideOnNull"
    :hasExpandList="hasExpandList"
    :subList="subList"
    :versionTimestampKey="versionTimestampKey"
    :hasSequence="hasSequence"
    :customBtns="_customBtns"
    :titleKey="'last_version.name'"
    :editable="editable"
    :staticModelData="$_expandListStaticModelData"
    :customCreateAction="$_expandListCustomSubmitAction"
    :customUpdateAction="$_expandListCustomSubmitAction"
    @input="$_getModelData($event)"
    @unbind-item-from-parent="$_onUnbindItemFromParent($event)"
  ></WsVersion>
</template>

<script>
import model from "@/models/checklist_template";
import submodel from "@/models/checklist_question_template";
import H_checklistQuestionTemplate from '@/helpers/checklistQuestionTemplate';

export default {
  data: () => ({
    modelName: model.modelName,
    versionModelName: model.versionModelName,
    versionFields: model.fields.last_version.fields,
    hideOnNull: false,
    hasExpandList: true,
    hasSequence: true,
    modelData: null,
    editable: true,
    versionTimestampKey: model.versionTimestampKey,
    showFields: ["locales", "updated_at", "updated_admin", ],
    subList: {
      type: "expandList",
      label: submodel.label,
      modelName: submodel.modelName,
      modelVersionName: "v2/cklist_ques_tmp_ver",
      modelNameInParams: false,
      modelTemplateNameInParams: true,
      modeParent: true,
      modeParentVersions: false,
      modeVersions: true,
      fields: submodel.fields,
      titleKey: "last_version.title",
      fieldsRead: submodel.fieldsRead,
      searchMode: false,
      hideOnNull: true,
      isGetAll: true,
      isVersionAPI: false,
      itemDeletable: false,
      itemEditable: false,
      itemVersionLinkCreatable: false,
      itemVersionCreatable: false,
      itemVersionReadable: true,
      itemLinkCheckable: false,
      fetchWithParams: true,
      orderBy: "created_at",
      customParentData: (parentData) => {
        return {
          version_status: parentData.last_version.version_status,
          area: parentData.area.id,
        };
      },
    }
  }),
  methods:{
    $_getModelData($event) {
      this.modelData = $event;
    },
    async $_onUnbindItemFromParent($event){
      try {
        const checklist_template_versions = { checklist_template_versions: [$event.parentId]}
        await this.$axios.post(`/cklist_ques_tmp_ver/${$event.itemId}/remove`, checklist_template_versions);
      } catch(error) {
        alert(error)
      }
    },
    $_expandListStaticModelData(rawData) {
      return H_checklistQuestionTemplate.setShowData(rawData);
    },
    $_expandListCustomSubmitAction(rawData){
      return H_checklistQuestionTemplate.setSubmitData(rawData);
    }
  },
  computed:{
    _itemEditable() {
      if (this.modelData) {
        if (this.modelData.last_version) {
          if (!this.modelData.last_version.version_status) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    _itemVersionCreatable() {
      if (this.modelData) {
        if (this.modelData.last_version) {
          if (!this.modelData.last_version.version_status) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    _itemVersionReadable() {
      if (this.modelData) {
        if (this.modelData.last_version) {
          if (!this.modelData.last_version.version_status) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    _customBtns() {
      return [
        {
          tooltip: `刪除`,
          checkDisplayOnModelData: function(){return false},
          isDisplay: true,
          icon: "mdi-delete",
          emit: "unbind-item-from-parent",
          customFunction: function(modelDatas, event) {
            if (!modelDatas || !event.itemId) return
            const tarIndex = modelDatas.findIndex((e) => {
              return e.last_version.id === event.itemId
            });
            modelDatas.splice(tarIndex, 1);
          }
        },
      ];
    },
  },
  watch:{
    _itemEditable: function(){
      this.subList.itemEditable = this._itemEditable
    },
    _itemVersionCreatable: function() {
      this.subList.itemVersionCreatable = this._itemVersionCreatable
    },
    _itemVersionReadable: function() {
      this.subList.itemVersionReadable = this._itemVersionReadable
    }
  }
};
</script>